module.exports = __webpack_public_path__ + "static/media/logo_karajan_light.cfb8041c.svg";